import React from "react";
import Styles from "./index.module.scss";
import TimeTable from "../List/Components/TimeTable";

const Index = () => {
    return (
        <div className={Styles.root}>
            <TimeTable />
        </div>
    );
};

export default Index;
